module.exports = __webpack_public_path__ + "static/media/customization.d95e488c.svg";